import { BaseModel } from "./BaseModel";

export class BlocklistEntry extends BaseModel {
  schema = "/blocklistentry";
  constructor(params) {
    return super(params, "/blocklistentry");
  }
}
